import { tr } from '@/i18n';

/**
 * The API answers in English. Its fixed messages (the `detail` of a refusal)
 * have Arabic and Russian translations stored as `api.<hash>` strings, where
 * the hash is FNV-1a (32-bit, hex) of the exact English text — the backend's
 * data migrations compute the same key. Unknown or dynamic messages stay as sent.
 */
export function apiMessageKey(text: string): string {
  let h = 0x811c9dc5;
  for (const byte of new TextEncoder().encode(text)) {
    h ^= byte;
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return `api.${h.toString(16).padStart(8, '0')}`;
}

/** `text` in the interface language when it is a known API message. */
export function localizeApiMessage(text: string): string {
  const t = text.trim();
  return t ? tr(apiMessageKey(t), text) : text;
}
